import { EffectsModule } from '@ngrx/effects';
import { SharedModule } from 'libs/shared/src/lib/shared.module';
import { SpinnersModule } from '@cradua/spinners';
import { EpimsDashboardNavModule } from '@cradua/epims-dashboard-nav';
import { AngularMaterialModule } from '@cradua/material';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Route } from '@angular/router';
import { PipelinedetailsComponent } from './components/pipelinedetails/pipelinedetails.component';
import { PipelinedetailsContainerComponent } from './containers/pipelinedetails-container/pipelinedetails-container.component';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PipelinedetailsEffects } from './states/+pipelinedetails/pipelinedetails.effects';
import { PipelinedetailsFacade } from './states/+pipelinedetails/pipelinedetails.facade';
import { StoreModule } from '@ngrx/store';
import * as pipelinedetailsReducer from "./states/+pipelinedetails/pipelinedetails.reducer";
import * as pipelineGenericReducer from "./states/+pipeline-generic/pipeline-generic.reducer";
import * as fromPipeline from './states';
import { PipelineRoutingModule } from './pipeline-routing.module';
import { PipelinesectionComponent } from './components/pipelinesection/pipelinesection.component';
import { PipelineassetlinkComponent } from './components/pipelinedetails/pipelineassetlink/pipelineassetlink.component';
import { AccountablefunctionComponent } from './components/pipelinedetails/accountablefunction/accountablefunction.component';
import { SearchComponent } from './components/search/search.component';
import { PipelineListComponent } from './components/pipeline-list/pipeline-list.component';
import { PlStageActivityContainerComponent } from './containers/pl-stage-activity-container/pl-stage-activity-container.component';
import { AddPlStageActivityComponent } from './components/add-pl-stage-activity/add-pl-stage-activity.component';
import { PlStageActivityComponent } from './components/pl-stage-activity/pl-stage-activity.component';
import { AccountablefxnpopupComponent } from './components/accountablefxnpopup/accountablefxnpopup.component';
import { PipelineassetpopupComponent } from './components/pipelineassetpopup/pipelineassetpopup.component';
import { PipelineGenericEffects } from './states/+pipeline-generic/pipeline-generic.effects';
import { PipelineGenericFacade } from './states/+pipeline-generic/pipeline-generic.facade';
import { GatewayFacade } from "libs/gateway/src/lib/states/+gateway/gateway.facades";
import { TemplateComponent } from './components/template/template.component';
import { PipelineassetpopupListComponent } from './components/pipelineassetpopup/pipelineassetpopup-list/pipelineassetpopup-list.component';
import { PipelineassetpopupSearchComponent } from './components/pipelineassetpopup/pipelineassetpopup-search/pipelineassetpopup-search.component';


export const epimsPipelineRoutes: Route[] = [];
@NgModule({
  imports: [CommonModule,
  RouterModule,
    PipelineRoutingModule,
    EpimsDashboardNavModule,
    SpinnersModule,
    ReactiveFormsModule,
    // BrowserAnimationsModule,
    AngularMaterialModule,
    StoreModule.forFeature(
      pipelinedetailsReducer.PIPELINEDETAILS_FEATURE_KEY,
      pipelinedetailsReducer.reducer
    ),
    StoreModule.forFeature(
      pipelineGenericReducer.PIPELINE_GENERIC_FEATURE_KEY,
      pipelineGenericReducer.reducer,
    ),
    
    StoreModule.forFeature(
      pipelineGenericReducer.PIPELINE_GENERIC_PIPELINE_SECTION_FEATURE_KEY,
      pipelineGenericReducer.pipelineSectionReducer,
    ),

    StoreModule.forFeature(
      pipelineGenericReducer.PIPELINE_GENERIC_ACCOUNTABLE_FUNCTION_LINK_FEATURE_KEY,
      pipelineGenericReducer.accountableFunctionReducer,
    ),

    StoreModule.forFeature(
      pipelineGenericReducer.PIPELINE_GENERIC_PIPELINE_ASSET_LINK_FEATURE_KEY,
      pipelineGenericReducer.pipelineAssetReducer,
    ),

    StoreModule.forFeature(
      pipelineGenericReducer.PIPELINE_GENERIC_LAND_TITLE_FEATURE_KEY,
      pipelineGenericReducer.landTitleReducer,
    ),

    StoreModule.forFeature(
      pipelineGenericReducer.PIPELINE_GENERIC_OPLLPTS_HISTORY_FEATURE_KEY,
      pipelineGenericReducer.opllPtsHistoryReducer,
    ),
  EffectsModule.forFeature([
    PipelinedetailsEffects,
    PipelineGenericEffects,
  ])

],
providers: [PipelinedetailsFacade,PipelineGenericFacade,GatewayFacade],
declarations: [
  PlStageActivityContainerComponent, AddPlStageActivityComponent,
  PipelinedetailsComponent, PipelinedetailsContainerComponent, 
  PipelinesectionComponent, PipelineassetlinkComponent, 
  TemplateComponent,
  PlStageActivityComponent, AccountablefunctionComponent, 
  SearchComponent, PipelineListComponent, AccountablefxnpopupComponent, PipelineassetpopupComponent
  , PipelineassetpopupListComponent, PipelineassetpopupSearchComponent],
})
export class PipelineModule {}
